"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function formatPhoneNumber(snils) {
  if (!snils) return '';
  return snils.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1-$2-$3-$4');
}
exports.default = formatPhoneNumber;